import { DollarSign, TrendingDown, Clock, Zap, ShieldCheck, Activity } from 'lucide-react'
import { MetricCard } from './metric-card'

interface KpiGridProps {
  metrics: {
    mrr: number
    churnRate: number
    activeTickets: number
    ticketVelocity: number
    slaCompliance: number
    criticalAlerts: number
  }
}

export function KpiGrid({ metrics }: KpiGridProps) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4">
      <MetricCard title="MRR" value={`$${((metrics.mrr || 0) / 1000).toFixed(1)}k`} trend={2.4} icon={DollarSign} />
      <MetricCard title="Churn" value={`${metrics.churnRate || 0}%`} trend={-0.2} icon={TrendingDown} />
      <MetricCard title="Tickets" value={metrics.activeTickets || 0} trend={-5} icon={Clock} />
      <MetricCard title="Velocity" value={`${(metrics.ticketVelocity || 0).toFixed(1)}/hr`} trend={12} icon={Zap} />
      <MetricCard title="SLA Compliance" value={`${(metrics.slaCompliance || 0).toFixed(1)}%`} trend={0.5} icon={ShieldCheck} />
      <MetricCard title="Critical P1 Alerts" value={metrics.criticalAlerts || 0} trend={metrics.criticalAlerts > 0 ? 100 : 0} icon={Activity} />
    </div>
  )
}
